import React from 'react';
import { Link } from 'react-router-dom';
import { X, Loader2, Building2 } from 'lucide-react';

// "Rattacher cet email" modal — CRM suggestions for the counterparty address.
export default function EmailLinkCrmModal({ open, onClose, counterpartyEmail, loading, suggestions, onLinkEntreprise }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="email-link-popover"
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[80vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b border-[#EFF0F6] flex items-center justify-between">
          <div>
            <h3 className="text-[15px] font-bold text-[#1A1B2E]">Rattacher cet email</h3>
            <div className="text-[11.5px] text-[#8E8FA5] mt-0.5">
              Adresse : <code className="text-[#4F46E5]">{counterpartyEmail}</code>
            </div>
          </div>
          <button onClick={onClose} className="text-[#8E8FA5] hover:text-[#1A1B2E]"><X className="w-4 h-4" /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {loading ? (
            <div className="text-center py-6 text-[#8E8FA5] text-[12.5px]"><Loader2 className="w-4 h-4 animate-spin inline-block mr-1" /> Recherche…</div>
          ) : (
            <>
              {suggestions.entreprises.length > 0 && (
                <section>
                  <h4 className="text-[11px] font-bold uppercase tracking-wide text-[#4F46E5] mb-1.5">Entreprises</h4>
                  <ul className="space-y-1">
                    {suggestions.entreprises.map((e) => (
                      <li key={e.id}>
                        <button
                          onClick={() => onLinkEntreprise(e.id)}
                          data-testid={`email-link-entreprise-${e.id}`}
                          className="w-full text-left px-3 py-2 rounded-lg border border-[#EFF0F6] hover:border-[#4F46E5] hover:bg-[#EEF2FF] text-[12.5px]"
                        >
                          <div className="flex items-center gap-2">
                            <Building2 className="w-3.5 h-3.5 text-[#4F46E5]" />
                            <span className="font-semibold text-[#1A1B2E]">{e.name}</span>
                          </div>
                          {e.contact_email && <div className="text-[11px] text-[#8E8FA5] ml-5">{e.contact_email}</div>}
                        </button>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              {suggestions.prospects.length > 0 && (
                <section>
                  <h4 className="text-[11px] font-bold uppercase tracking-wide text-[#4F46E5] mb-1.5">Prospects</h4>
                  <ul className="space-y-1">
                    {suggestions.prospects.map((p) => (
                      <li key={p.id} className="px-3 py-2 rounded-lg border border-[#EFF0F6] text-[12.5px]">
                        <div className="font-semibold text-[#1A1B2E]">{p.contact || p.company || p.email}</div>
                        <div className="text-[11px] text-[#8E8FA5]">{p.email}</div>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              {suggestions.learners.length > 0 && (
                <section>
                  <h4 className="text-[11px] font-bold uppercase tracking-wide text-[#4F46E5] mb-1.5">Apprenants</h4>
                  <ul className="space-y-1">
                    {suggestions.learners.map((l) => (
                      <li key={l.id} className="px-3 py-2 rounded-lg border border-[#EFF0F6] text-[12.5px]">
                        <div className="font-semibold text-[#1A1B2E]">{l.firstName} {l.lastName}</div>
                        <div className="text-[11px] text-[#8E8FA5]">{l.email}</div>
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              {!suggestions.entreprises.length && !suggestions.prospects.length && !suggestions.learners.length && (
                <div className="text-center py-6 text-[12.5px] text-[#8E8FA5]">
                  Aucune correspondance trouvée pour <code>{counterpartyEmail}</code>.
                  <div className="mt-2">
                    <Link
                      to={`/app/entreprises?new=1&email=${encodeURIComponent(counterpartyEmail || '')}`}
                      className="text-[#4F46E5] underline hover:no-underline font-semibold"
                    >
                      → Créer une entreprise avec cette adresse
                    </Link>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
